import { NotifyCenter } from "../notify-center";
import EventService from "../event.service";
import { EventMessage } from "../raysync/model-type";

export enum ConnectStatus {
  CONNECTING,
  CLOSED,
  CONNECTED,
  FAILED,
}

export class SocketService {
  _connectStatus: ConnectStatus = ConnectStatus.CLOSED;
  protected connection: WebSocket;
  constructor(protected eventBus: EventService) {
    this.connectStatus = ConnectStatus.CLOSED;
    this.eventBus = eventBus;
  }
  createConnect(serverUrl: string) {
    this.connectStatus = ConnectStatus.CONNECTING;
    this.connection = new WebSocket(serverUrl);
    this.connection.onopen = (event: Event) => {
      this.connectStatus = ConnectStatus.CONNECTED;
    };
    this.connection.onerror = (event: ErrorEvent) => console.error(event);
    this.connection.onclose = (event: CloseEvent) => console.warn(event);
    this.connection.onmessage = this.handleMessage.bind(this);
  }
  subscribe(eventName: string, callback: (...args) => void, once?) {
    this.eventBus.register(eventName, callback, once);
  }
  unsubscribe(key: string, handler?: (...args) => void) {
    this.eventBus.unregister(key, handler);
  }
  protected handleMessage(
    event: MessageEvent,
    callback?: (args: EventMessage) => any
  ) {
    const { cmd, body } = JSON.parse(event.data);
    this.eventBus.post(cmd, body);
  }
  set connectStatus(status: ConnectStatus) {
    this._connectStatus = status;
    NotifyCenter.raysyncConnectStatus.emit(status);
  }
  get connectStatus() {
    return this._connectStatus;
  }
}

/**
 * use
 * const port = 4577
 * const protocol = location.protocol.indexOf('https') === -1 ? 'ws:' : 'wss:'
 * const serverUrl = `${protocol}//${location.hostname}:${port}/`
 * const socketService = new SocketService()
 * this.socketService.createConnect(serverUrl)
 * provide: {
 *   socketService: this.socketService,
 * }
 */
